import { render, staticRenderFns } from "./ExpenseEligibilityWidget.vue?vue&type=template&id=2108493d&scoped=true"
import script from "./ExpenseEligibilityWidget.vue?vue&type=script&lang=ts"
export * from "./ExpenseEligibilityWidget.vue?vue&type=script&lang=ts"
import style0 from "./ExpenseEligibilityWidget.vue?vue&type=style&index=0&id=2108493d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2108493d",
  null
  
)

export default component.exports